// @ts-ignore
import events from 'events-bus';
import Constants from "../Constants";

export interface Event {
    key: string
    message: string
}

export const sendErrorEvent = (message: string) => {
    const e: Event = {key: Constants.EVENT.FORECAST_BOX.ERROR, message}
    checkEvent(e);

    const eventContent = {message: e.message};
    events.post(e.key, eventContent);
};

export const send = (event: Event) => {
    checkEvent(event);
    const eventContent = {
        message: event.message
    };
    events.post(Constants.EVENT.FORECAST_BOX.ERROR, eventContent);
};

function checkEvent(event: Event) {
    if (event.message.length === 0) {
        throw new Error('Event not formatted properly: ' + JSON.stringify(event))
    }
}
